<div class="container_dati_generali">
  <form #f="ngForm" [formGroup]="scadenzaForm" (ngSubmit)="submit()">
    <div class="container-dati-generali">
      <div class="row">
        <div
          comboModInput
          class="col-sm-4"
          formControlName="tipoScadenza"
          [labelInput]="'Tipo'"
          [mandatory]="true"
          [optionsCombo]="tipoScadenzaOptions"
          [control]="scadenzaForm.controls['tipoScadenza']"
          [labelOption]="'label'"
          [objectReference]="scadenzaForm.get('tipoScadenza').value"
          (onReturn)="scadenzaForm.get('tipoScadenza').setValue($event)"
        ></div>
        <div
          comboModInput
          class="col-sm-4"
          formControlName="motivo"
          [labelInput]="'Adempimento'"
          [mandatory]="true"
          [optionsCombo]="motivoScadenzaOptionsFiltrate"
          [control]="scadenzaForm.controls['motivo']"
          [labelOption]="'label'"
          [objectReference]="scadenzaForm.get('motivo').value"
          (onReturn)="scadenzaForm.get('motivo').setValue($event)"
        ></div>
        <div
          comboModInput
          class="col-sm-4"
          formControlName="priorita"
          [labelInput]="'Priorit&agrave;'"
          [mandatory]="true"
          [optionsCombo]="prioritaOptions"
          [control]="scadenzaForm.controls['priorita']"
          [labelOption]="'label'"
          [objectReference]="scadenzaForm.get('priorita').value"
          (onReturn)="scadenzaForm.get('priorita').setValue($event)"
        ></div>
      </div>
      <div class="row">
        <div
          datePickerInput
          class="col-sm-3"
          [control]="scadenzaForm.get('dataScadenza')"
          [labelInput]="'Data'"
          [mandatory]="true"
          formControlName="dataScadenza"
        ></div>
        <div
          oraComboInput
          [control]="scadenzaForm.get('ora')"
          [objectReferenceOra]="oraSet"
          [objectReferenceMin]="minSet"
          (onReturn)="ora = $event"
        ></div>
        <div
          datePickerInput
          class="col-sm-3"
          [control]="scadenzaForm.get('dataPromemoria')"
          [labelInput]="'Data Promemoria'"
          [mandatory]="false"
          formControlName="dataPromemoria"
        ></div>
        <div
          checkBoxRadio
          class="col-sm-2"
          [labelInput]="'Pubblico'"
          idInput="pubblica"
          [control]="scadenzaForm.controls['pubblica']"
          [objectReference]="scadenzaForm.get('pubblica').value"
          (onReturn)="scadenzaForm.get('pubblica').setValue($event)"
        ></div>
      </div>
      <div class="row">
        <div
          checkBoxRadio
          class="col-sm-3"
          [labelInput]="'Evasione'"
          idInput="evasa"
          [control]="scadenzaForm.controls['evasa']"
          [objectReference]="scadenzaForm.get('evasa').value"
          (onReturn)="onEvasa($event)"
        ></div>
        <div ng-select-combo class="col-sm-3"
            formControlName="motivoEvasione"
            [label]="'Motivo evasione'"
            [required]="false"
            [disabled]="!scadenzaForm.get('evasa').value"
            [options]="motivoEvasioneOptions"
            [optionSel]="scadenzaForm.get('motivoEvasione').value"
            (onChangeSel)="scadenzaForm.get('motivoEvasione').setValue($event)">
        </div>
        <div
          datePickerInput
          class="col-sm-3"
          [control]="scadenzaForm.get('dataEvasione')"
          [labelInput]="'Data Evasione'"
          [mandatory]="false"
          formControlName="dataEvasione"
          [submitPending]="scadenzaForm.get('dataEvasione').disabled"
        ></div>
        <div
          textInput
          [control]="scadenzaForm.controls['appunto']"
          class="col-sm-3"
          [labelInput]="'Appunto (max 255)'"
          formControlName="appunto"
        ></div>
      </div>
      <div class="row">
        <div
          textAreaInput
          class="col-sm-12"
          [labelInput]="'Note'"
          formControlName="note"
        ></div>
      </div>
      <div class="row">
        <p class="mandatory col-sm-12">
          <em>* Campi obbligatori</em>
        </p>
      </div>
      <div class="row pb-10">
        <p class="col-sm-3 col-xs-6">
          <button
            type="button"
            class="btn btn-outline-secondary btn-block"
            (click)="createForm()"
          >
            Pulisci campi
          </button>
        </p>
        <p class="col-sm-3 col-xs-6 col-sm-offset-6">
          <button
            type="submit"
            class="btn btn-primary btn-block"
            [disabled]="!scadenzaForm.valid"
          >
            Aggiungi Adempimento
          </button>
        </p>
      </div>
    </div>
  </form>
</div>
